import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import hero1 from '../assets/hero1.jpg';
import hero2 from '../assets/hero2.jpg';
import hero3 from '../assets/hero3.jpg';

const Home = () => {
  return (
    <div className="w-full bg-white">

      {/* HERO CARRUSEL */}
      <section className="relative w-full h-[80vh]">
        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          loop
          speed={4000} // duración de la transición en milisegundos
  autoplay={{ delay: 4000, disableOnInteraction: false }}
          className="w-full h-full"
        >
          {[hero1, hero2, hero3].map((img, idx) => (
            <SwiperSlide key={idx}>
              <img src={img} alt={`Slide ${idx + 1}`} className="w-full h-full object-cover brightness-[0.6] z-10" />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-20">
          {/* ✅ Texto superior */}
          <p className="text-base md:text-lg mb-4 tracking-widest uppercase text-white/90">
            Belleza, Ciencia, Confianza.
          </p>

          {/* Título principal */}
          <h1 className="text-4xl md:text-6xl font-serif mb-4">Centro Medico Laser Corium</h1>

          {/* Subtítulo */}
          <p className="text-lg md:text-xl max-w-2xl">
            Estética avanzada y cuidado personalizado. Resultados visibles y duraderos.
          </p>

          {/* Botón CTA */}
          <button className="mt-6 px-6 py-3 bg-white text-dark font-semibold rounded-full shadow-md hover:bg-primary hover:text-white transition">
            Agendar Cita
          </button>
        </div>
      </section>

      {/* SOBRE NOSOTROS */}
      <section className="py-8 px-6 bg-[#f8f4f2] text-center">
        <h2 className="text-3xl font-serif mb-4 text-primary">Bienvenida a Corium</h2>
        <p className="max-w-3xl mx-auto text-gray-700 text-lg leading-relaxed">
          Clínica Corium es un centro de estética de prestigio que se distingue por su enfoque en tratamientos avanzados,
          personalización del cuidado y una experiencia excepcional. Utilizamos tecnología de vanguardia y productos de alta calidad para garantizar resultados visibles, duraderos y seguros.
        </p>
      </section>

      {/* PILARES */}
      <section className="py-10 px-6 text-center">
        <h3 className="text-2xl font-serif mb-10 text-primary">Nuestros Pilares</h3>
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8 text-left text-gray-600 text-sm leading-6">
          <div>
            <h4 className="text-lg font-semibold mb-2">Tratamientos avanzados</h4>
            <p>Desde limpiezas hasta procedimientos con láser, microagujas y radiofrecuencia.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Personalización</h4>
            <p>Análisis detallado de la piel y planes de tratamiento a medida para cada paciente.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Tecnología y productos</h4>
            <p>Solo trabajamos con tecnología de punta y productos certificados de alta gama.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Resultados duraderos</h4>
            <p>Buscamos cambios visibles, reales y sostenibles en la apariencia y bienestar.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Atención al cliente</h4>
            <p>Seguimiento cercano, resolución de dudas y acompañamiento antes, durante y después.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Profesionales calificados</h4>
            <p>Equipo experto, con amplia formación y compromiso con tu seguridad y salud.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
